export class ProfilePageState {
  public isEditing: boolean;
  public error: object | null;

  constructor() {
    this.isEditing = false;
    this.error = null;
  }
}
